import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import { Link } from 'react-scroll';
import './Banner.css'

const About = () => {
  const [ref,inView]=useInView({
    threshold:0.5,
  });
  return <section className='section' id='about' ref={ref}>
    <div className='container mx-auto'>
      
      <div className='flex flex-col gap-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 h-screen '>
        <motion.div variants={fadeIn('right',0.3)} initial='hidden' whileInView={"show"} viewport={{once:false,amount:0.3}} className='flex-1 bg-about bg-contain bg-no-repeat h-[640px] mix-blend-lighten bg-top'>        </motion.div>
        <motion.div variants={fadeIn('left',0.5)} initial='hidden' whileInView={"show"} viewport={{once:false,amount:0.3}} className='flex-1'>
          <h2 className='h2 text-accent'>About Me!!</h2>
          <h3 className='h3 mb-4'>
            My name is Piyush Narula.<br></br> I am Currently a Sophomore.<br></br>
            I am Persuing my B.Tech in Computer Science and Engineering with Ai From IIITD.
          </h3>
          <p className='mb-6'>
          <br></br>💬 Let's talk about tech.<br></br>⚡️ Hope to collaborate soon.
          </p>
          <div>
            _
          </div>
          <div className='flex gap-x-6 lg:gap-x-10 mb-12'>
          <div>
              <div className='text-[40px] font-tertiary text-gradient mb-2'>
                {
                  inView?<CountUp start={0} end={19} duration={4} redraw={true}/>:null}
              </div>
              <div className='font-primary text-sm tracking-[2px]'>
                Years Old
              </div>
            </div>
            
            <div>
              <div className='text-[40px] font-tertiary text-gradient mb-2'>
                {
                  inView?<CountUp start={0} end={10} duration={4} redraw={true}/>:null}+
              </div>
              <div className='font-primary text-sm tracking-[2px]'>
                Projects <br></br>
                Completed
              </div>
            </div>
            
          </div>
          
          <div className='flex gap-x-8 items-center'>
          <Link to='contact' activeClass='active' spy={true} smooth={true}>
              <button className='btn btn-lg'>Contact Me</button>
              </Link>
              <a href='https://my-portfolio-alpha-five-27.vercel.app/' className='text-gradient btn-link'>
                My Portfolio
              </a>
              
            </div>
            
        </motion.div>
      </div>
      
    </div>
    
  </section>;
};

export default About;
